// Needs to be kept up to date with report.constants.ts::INTERACTIVE_CONTENT_WORKSTEP_VERSION
export const WORKSTEP_SCHEMA_VERSION = 91;
// Requests to get worksteps will be rejected with this value when there are no worksteps to get
export const WORKSHEET_WITH_NO_WORKSTEPS = 'WORKSHEET_WITH_NO_WORKSTEPS';
// Requests to push worksteps will be rejected with this value when those requests are disabled for our viewing mode
export const WORKSTEP_PUSH_DISABLED = 'WORKSTEP_PUSH_DISABLED';
